import { ReportsListPage } from './ReportsListPage';

export const reportsRoutes = [
  {
    path: '',
    element: <ReportsListPage />,
  },
];
